// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode';

export default function getUserRole() {
  const JWT = localStorage.getItem('accessToken');

  if (JWT) {
    const decode = jwt_decode(JWT);

    return decode?.role;
  }
  return null;
}
